<template>
	<div v-if="!listloading">
		<el-col :span="24" class="toolbar uptool" style="padding-bottom: 0px;">
			<el-form :inline="true">
				<el-form-item>
					<el-button type="text" size="small" style="margin-left:10px;color: #000;cursor: auto;">DID：</el-button>
				</el-form-item>
				<el-form-item>
					<el-input placeholder="请输入内容" v-model="DIDinput" clearable size="small"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="text" size="small" style="margin-left:10px;color: #000;cursor: auto;">发货日期：</el-button>
				</el-form-item>
				<el-form-item>
					<el-date-picker size="small" v-model="selectTime" value-format="timestamp" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-button type="text" size="small" style="margin-left:10px;color: #000;cursor: auto;">经销商：</el-button>
				</el-form-item>
				<el-form-item>
					<el-select collapse-tags v-model="selectJxs" placeholder="请选择" multiple size="small" style="min-width: 400px;" @change="changeJxs" >
						<el-option v-for="item in Dealerlist" :key="item.id" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" plain icon="el-icon-search" size="small" @click="search">搜索</el-button>
				</el-form-item>
				<el-form-item style="float: right;">
					<el-button type="primary" plain size="small" @click="refresh">重置刷新</el-button>
				</el-form-item>
				<!--<el-form-item id="onlineSelect">
					<el-input placeholder="请输入（支持模糊搜索）" v-model="inputWhat" class="input-with-select" size="small">
						<el-select v-model="selectWhat" slot="prepend" placeholder="请选择类别">
							<el-option v-for="item in Choice" :label='item.name' :key='item.val' :value='item.val'></el-option>
						</el-select>
					    <el-button slot="append" icon="el-icon-plus" @click="addCondition">添加条件</el-button>
					</el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="text" size="small" style="margin-left:10px;color: #000;cursor: auto;">条 件 项：</el-button>
				</el-form-item>
				<el-form-item>
					<div id="Addbox">
						<el-tag type="success" :key="tag" v-for="tag in Tags" closable :disable-transitions="false" @close="TagsHandleClose(tag)" style="margin-right: 10px;" size="medium">{{tag}}</el-tag>
					</div>
				</el-form-item>	-->
				
				
				<!--<el-form-item style="float: right;">
					<el-button type="primary" plain size="small">刷新</el-button>
				</el-form-item>-->
			</el-form>
			<el-form :inline="true">
				<el-form-item>
					<span :span="4" style="line-height: 41px;font-size: 16px;color: blue;margin-left: 10px;">*蓝色字体为当前账号可修改部分，双击当前行弹出修改页面。</span>
				</el-form-item>
			</el-form>	
			<!--<el-form :inline="true">
				<el-form-item>
					<el-button type="text" size="small" style="margin-left:10px;color: #000;cursor: auto;">产品类别：</el-button>
				</el-form-item>
				<el-form-item>
					<el-select v-model="selectKind" multiple placeholder="请选择" size="small" style="width: 200px;">
						<el-option label="终端客户（个人）" value="1"></el-option>
	    				<el-option label="终端客户（单位）" value="5"></el-option>
	    				<el-option label="经销商客户（购销）" value="2"></el-option>
	    				<el-option label="经销商客户（押金）" value="6"></el-option>
	    				<el-option label="公司内部（市场）" value="3"></el-option>
	    				<el-option label="公司内部（研发）" value="7"></el-option>
	    				<el-option label="其他" value="4"></el-option>
					</el-select>
				</el-form-item>
				
				<el-form-item>
					<el-button type="text" size="small" style="margin-left:10px;color: #000;cursor: auto;">颜色：</el-button>
				</el-form-item>
				<el-form-item>
					<el-select v-model="selectColor" multiple placeholder="请选择" size="small" style="width: 120px;">
						<el-option label="黑金" value="1"></el-option>
	    				<el-option label="白红" value="2"></el-option>
	    				<el-option label="白灰" value="3"></el-option>
	    				<el-option label="样机" value="5"></el-option>
	    				<el-option label="钢铁侠" value="6"></el-option>
	    				<el-option label="白色" value="256"></el-option>
	    				<el-option label="红色" value="257"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="text" size="small" style="margin-left:10px;color: #000;cursor: auto;">经销商：</el-button>
				</el-form-item>
				<el-form-item>
					<el-select v-model="selectJxs" placeholder="请选择" multiple size="small" style="min-width: 300px;" @change="changeJxs" >
						<el-option v-for="item in Dealerlist" :key="item.id" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
			</el-form>-->
			<!--<el-form :inline="true">
				<el-form-item>
					<el-button type="text" size="small" style="margin-left:10px;color: #000;cursor: auto;">发货日期：</el-button>
				</el-form-item>
				<el-form-item>
					<el-date-picker size="small" v-model="selectTime" value-format="timestamp" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" plain icon="el-icon-search" size="mini">搜索</el-button>
				</el-form-item>
			</el-form>-->
			<el-form :inline="true" id="addMessage">
				<el-form-item>
					<el-button type="text" size="small" style="margin-left:10px;color: #000;cursor: auto;">显示内容:</el-button>
				</el-form-item>
				<el-form-item>
				<el-checkbox-group v-model="checkList" @change="showChange">
			    <el-checkbox label="a">财务模块</el-checkbox>
			    <el-checkbox label="b">销售模块</el-checkbox>
			    <el-checkbox label="c">生产模块</el-checkbox>
			    <el-checkbox label="d">产品模块</el-checkbox>
			  </el-checkbox-group>
			  </el-form-item>
			</el-form>
		</el-col>

		<el-table id="dataTable" :data="List" border v-loading="listloading" element-loading-text="拼命加载中" element-loading-background="rgba(0, 0, 0, 0.8)" element-loading-spinner="el-icon-loading" style="width: 99.9%" :max-height="maxHeight" @filter-change="Filterfind" @row-dblclick="ChangeIt">
			<el-table-column label="序号" fixed prop="sequenceNumber" width="55"></el-table-column>
			<el-table-column label="DID" fixed prop="did" min-width="110"></el-table-column>
			<el-table-column label="MAC" prop="mac" min-width="140"></el-table-column>
			
			<el-table-column label="颜色" prop="color_code" min-width="90">
				<template slot-scope="scope">
					{{colorCode(scope.row.color_code)}}
				</template>
			</el-table-column>
			<el-table-column label="版本" prop="color_code" min-width="90">
				<template slot-scope="scope">
					{{EditionCode(scope.row.edition_code)}}
				</template>
			</el-table-column>
			<el-table-column label="发货单号" prop="deliveryOrder.serial_number" min-width="200"></el-table-column>
			<el-table-column label="发货日期" prop="deliveryOrder.delivery_date" min-width="110">
				<template slot-scope="scope">
					{{timeFormate(scope.row.deliveryOrder.delivery_date)}}
				</template>
			</el-table-column>
			<el-table-column label="发货人" prop="deliveryOrder.shipper" min-width="110"></el-table-column>
		<el-table-column label="财务模块" align="center" v-if="cw">
			<el-table-column label="开票日期" prop="invoice.invoice_created_date" width="110">
				<template slot-scope="scope">
					<span class="changeColor" v-if="limB">{{timeFormate(scope.row.invoice.invoice_created_date)}}</span>
					<span v-else>{{timeFormate(scope.row.invoice.invoice_created_date)}}</span>
				</template>
			</el-table-column>
			<el-table-column label="开票状态" prop="invoice.invoice_status" width="110">
				<template slot-scope="scope">
					<span class="changeColor" v-if="limB">{{invoiceState(scope.row.invoice.invoice_status)}}</span>
					<span v-else>{{invoiceState(scope.row.invoice.invoice_status)}}</span>
				</template>
			</el-table-column>
			<el-table-column label="发票编号" width="200">
				<template slot-scope="scope">
					<span class="changeColor" v-if="limB">{{scope.row.invoice.invoice_serial_number}}</span>
					<span v-else>{{scope.row.invoice.invoice_serial_number}}</span>
				</template>
			</el-table-column>
			<el-table-column label="收款日期1st" prop="invoice.receipt_date" width="110">
				<template slot-scope="scope">
					<span class="changeColor" v-if="limB">{{timeFormate(scope.row.invoice.receipt_date)}}</span>
					<span v-else>{{timeFormate(scope.row.invoice.receipt_date)}}</span>
				</template>
			</el-table-column>
			<el-table-column label="收款金额1st" prop="invoice.receipt_amount" width="200">
				<template slot-scope="scope">
					<span class="changeColor" v-if="limB">{{scope.row.invoice.receipt_amount}}</span>
					<span v-else>{{scope.row.invoice.receipt_amount}}</span>
				</template>
			</el-table-column>
			<el-table-column label="收款日期2nd" prop="invoice.receipt_date" width="110">
				<template slot-scope="scope">
					<span class="changeColor" v-if="limB">{{timeFormate(scope.row.invoice.receipt_date_2nd)}}</span>
					<span v-else>{{timeFormate(scope.row.invoice.receipt_date_2nd)}}</span>
				</template>
			</el-table-column>
			<el-table-column label="收款金额2nd" prop="invoice.receipt_amount" width="200">
				<template slot-scope="scope">
					<span class="changeColor" v-if="limB">{{scope.row.invoice.receipt_amount_2nd}}</span>
					<span v-else>{{scope.row.invoice.receipt_amount_2nd}}</span>
				</template>
			</el-table-column>
			<el-table-column label="收款日期3rd&after" prop="invoice.receipt_date" width="110">
				<template slot-scope="scope">
					<span class="changeColor" v-if="limB">{{timeFormate(scope.row.invoice.receipt_date_finally)}}</span>
					<span v-else>{{timeFormate(scope.row.invoice.receipt_date_finally)}}</span>
				</template>
			</el-table-column>
			<el-table-column label="收款金额3rd&after" prop="invoice.receipt_amount" width="200">
				<template slot-scope="scope">
					<span class="changeColor" v-if="limB">{{scope.row.invoice.receipt_amount_finally}}</span>
					<span v-else>{{scope.row.invoice.receipt_amount_finally}}</span>
				</template>
			</el-table-column>
			<el-table-column label="收款状态" prop="invoice.receipt_status" width="110">
				<template slot-scope="scope">
					<span class="changeColor" v-if="limB">{{paymentState(scope.row.invoice.receipt_status)}}</span>
					<span v-else>{{paymentState(scope.row.invoice.receipt_status)}}</span>
				</template>
			</el-table-column>
			<el-table-column label="押金转销售" width="110">
				<template slot-scope="scope">
					<span class="changeColor" v-if="limB">{{cashtosell(scope.row.invoice.is_deposit_to_sale)}}</span>
					<span v-else>{{cashtosell(scope.row.invoice.is_deposit_to_sale)}}</span>
				</template>
			</el-table-column>
			<!--<el-table-column label="物流单号" width="110">
				<template slot-scope="scope">
					<span class="changeColor" v-if="limC">{{scope.row.deliveryOrder.shipment_number}}</span>
					<span v-else>{{scope.row.deliveryOrder.shipment_number}}</span>
				</template>
			</el-table-column>-->
			</el-table-column>
			<el-table-column label="销售模块" align="center" v-if="xs">
			<el-table-column label="产品类别" width="160">
				<template slot-scope="scope">
					<span class="changeColor" v-if="limC">{{typeCodeForm(scope.row.deliveryOrder.type_code)}}</span>
					<span v-else>{{typeCodeForm(scope.row.deliveryOrder.type_code)}}</span>
				</template>
			</el-table-column>
			
			<el-table-column label="合同收款方式" width="150">
				<template slot-scope="scope">
					<span class="changeColor" v-if="limC">{{scope.row.contract.contract_payment_method}}</span>
					<span v-else>{{scope.row.contract.contract_payment_method}}</span>
				</template>
			</el-table-column>
			<el-table-column label="合同收款时间" width="120">
				<template slot-scope="scope">
					<span class="changeColor" v-if="limC">{{timeFormate(scope.row.contract.contract_collection_date)}}</span>
					<span v-else>{{timeFormate(scope.row.contract.contract_collection_date)}}</span>
				</template>
			</el-table-column>
			<el-table-column label="合同编号" prop="contract.contract_serial_number" width="200">
				<template slot-scope="scope">
					<span class="changeColor" v-if="limC">{{scope.row.contract.contract_serial_number}}</span>
					<span v-else>{{scope.row.contract.contract_serial_number}}</span>
				</template>
			</el-table-column>
			<el-table-column label="合同金额" prop="contract.contract_amount" width="200">
				<template slot-scope="scope">
					<span class="changeColor" v-if="limC">{{scope.row.contract.contract_amount}}</span>
					<span v-else>{{scope.row.contract.contract_amount}}</span>
				</template>
			</el-table-column>
			<el-table-column label="合同状态" prop="contract.contract_status" width="110">
				<template slot-scope="scope">
					<span class="changeColor" v-if="limC">{{contractState(scope.row.contract.contract_status)}}</span>
					<span v-else>{{contractState(scope.row.contract.contract_status)}}</span>
				</template>
			</el-table-column>
		
			<el-table-column label="经销商" width="300">
				<template slot-scope="scope">
					{{jxs(scope.row.dealer_id)}}
				</template>
			</el-table-column>
			<el-table-column label="产品所在地" width="400">
				<template slot-scope="scope">
					<span class="changeColor" v-if="limC">{{scope.row.add}}</span>
					<span v-else>{{scope.row.add}}</span>
				</template>
			</el-table-column>
			<!--<el-table-column label="用户" width="200">
				<template slot-scope="scope">
					<span class="changeColor" v-if="limC">{{scope.row.purchaserInfo.customer}}</span>
					<span v-else>{{scope.row.purchaserInfo.customer}}</span>
				</template>
			</el-table-column>
			<el-table-column label="用户联系方式" width="200">
				<template slot-scope="scope">
					<span class="changeColor" v-if="limC">{{scope.row.purchaserInfo.customer_phone}}</span>
					<span v-else>{{scope.row.purchaserInfo.customer_phone}}</span>
				</template>
			</el-table-column>-->
			<el-table-column label="用户/设备负责人" width="200">
				<template slot-scope="scope">
					<span class="changeColor" v-if="limC">{{scope.row.purchaserInfo.manager}}</span>
					<span v-else>{{scope.row.purchaserInfo.manager}}</span>
				</template>
			</el-table-column>
			<el-table-column label="联系方式" width="200">
				<template slot-scope="scope">
					<span class="changeColor" v-if="limC">{{scope.row.purchaserInfo.manager_phone}}</span>
					<span v-else>{{scope.row.purchaserInfo.manager_phone}}</span>
				</template>
			</el-table-column>
			<el-table-column label="客户特殊需求" width="200">
				<template slot-scope="scope">
					<span class="changeColor" v-if="limC">{{scope.row.purchaserInfo.customer_special_needs}}</span>
					<span v-else>{{scope.row.purchaserInfo.customer_special_needs}}</span>
				</template>
			</el-table-column>
			</el-table-column>
			<el-table-column label="生产模块" align="center" v-if="sc">
			<el-table-column label="穿戴配套" prop="deliveryOrder.wearable_device" width="200">
				<template slot-scope="scope">
					<span class="changeColor" v-if="limA">
						<span v-if="scope.row.deliveryOrder.wearable_device">
							<ul class="wareUl">
								<li v-if="(scope.row.deliveryOrder.wearable_device >> 24) & 255">XL: {{(scope.row.deliveryOrder.wearable_device >> 24) & 255}}</li>
								<li v-if="(scope.row.deliveryOrder.wearable_device >> 16) & 255">M: {{(scope.row.deliveryOrder.wearable_device >> 16) & 255}}</li>
								<li v-if="(scope.row.deliveryOrder.wearable_device >> 8) & 255">S: {{(scope.row.deliveryOrder.wearable_device >> 8) & 255}}</li>
								<li v-if="scope.row.deliveryOrder.wearable_device & 255">N: {{scope.row.deliveryOrder.wearable_device & 255}}</li>
							</ul>
						</span>
						<span v-else>无</span>
					</span>
					<span v-else>
						<span v-if="scope.row.deliveryOrder.wearable_device">
							<ul class="wareUl">
								<li v-if="(scope.row.deliveryOrder.wearable_device >> 24) & 255">XL: {{(scope.row.deliveryOrder.wearable_device >> 24) & 255}}</li>
								<li v-if="(scope.row.deliveryOrder.wearable_device >> 16) & 255">M: {{(scope.row.deliveryOrder.wearable_device >> 16) & 255}}</li>
								<li v-if="(scope.row.deliveryOrder.wearable_device >> 8) & 255">S: {{(scope.row.deliveryOrder.wearable_device >> 8) & 255}}</li>
								<li v-if="scope.row.deliveryOrder.wearable_device & 255">N: {{scope.row.deliveryOrder.wearable_device & 255}}</li>
							</ul>
						</span>
						<span v-else>无</span>
					</span>
				</template>
			</el-table-column>
			<el-table-column label="气弹簧" width="90">
				<template slot-scope="scope">
					<span>{{springCode(scope.row.spring_code)}}</span>
				</template>
			</el-table-column>
			<el-table-column label="产品版本号" prop="version_number" width="200">
				<template slot-scope="scope">
					<span class="changeColor" v-if="limA">{{scope.row.version_number}}</span>
					<span v-else>{{scope.row.version_number}}</span>
				</template>
			</el-table-column>
			</el-table-column>
			<el-table-column label="产品模块" align="center" v-if="cp">
			<el-table-column label="销售时间" width="160">
				<template slot-scope="scope">
					<span class="changeColor" v-if="limD">{{timeFormate(scope.row.afterSaleOrder.sales_date)}}</span>
					<span v-else>{{timeFormate(scope.row.afterSaleOrder.sales_date)}}</span>
				</template>
			</el-table-column>
			<el-table-column label="问题记录" width="200">
				<template slot-scope="scope">
					<span class="changeColor" v-if="limD">{{problemRecord(scope.row.afterSaleOrder.problemCodes)}}</span>
					<span v-else>{{problemRecord(scope.row.afterSaleOrder.problemCodes)}}</span>
				</template>
			</el-table-column>
			<el-table-column label="备注" width="200">
				<template slot-scope="scope">
					<span class="changeColor" v-if="limD">{{scope.row.afterSaleOrder.remark}}</span>
					<span v-else>{{scope.row.afterSaleOrder.remark}}</span>
				</template>
			</el-table-column>
			</el-table-column>
		</el-table>
		<el-col :span="24" class="toolbar downtool">
			<el-button type="primary" @click="DownExcel" size="small">导出到Excel</el-button>
			<el-pagination :span="20" layout="total,sizes,prev, pager, next" @current-change="handleCurrentChange" @size-change="handleSizeChange" :page-sizes="[20,30,40,50]" :page-size="Pagesize" :current-page="Curpage" :total="total" style="float:right;">
			</el-pagination>
		</el-col>

		<!--生产修改弹窗-->
		<el-dialog title="生产页面" :visible.sync="SCvisible" width="520px" append-to-body center>
			<el-form :model="form1">
				<el-form-item label="穿戴佩戴情况：" :label-width="formLabelWidth">
					<p><span style="display: inline-block;width: 50px;">N: </span><el-input-number size="mini" v-model="form1.ChuanDaiN"></el-input-number></p>
					<p><span style="display: inline-block;width: 50px;">XL: </span><el-input-number size="mini" v-model="form1.ChuanDaiXL"></el-input-number></p>
					<p><span style="display: inline-block;width: 50px;">M: </span><el-input-number size="mini" v-model="form1.ChuanDaiM"></el-input-number></p>
					<p><span style="display: inline-block;width: 50px;">S: </span><el-input-number size="mini" v-model="form1.ChuanDaiS"></el-input-number></p>
				</el-form-item>
				<el-form-item label="产品版本号：" :label-width="formLabelWidth">
					<el-input placeholder="请填写修改内容" v-model="form1.BanBen" auto-complete="off" :maxlength='50'></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" type="primary" @click="Sub1" :loading="Subloading1" style="padding: 10px 50px;">提 交</el-button>
			</div>
		</el-dialog>
		<el-dialog title="提示" :visible.sync="SCTSVisible" width="30%">
			<span>是否确认修改并提交</span>
			<span slot="footer" class="dialog-footer">
				    <el-button @click="SCTSVisible = false">取 消</el-button>
				    <el-button type="primary" @click="Subdata1">确 定</el-button>
				</span>
		</el-dialog>
		<!--财务修改弹窗-->
		<el-dialog title="财务修改" :visible.sync="CWvisible" append-to-body center width="540px">
			<el-form :model="form2">
				<el-form-item label="开票日期：" :label-width="formLabelWidth2">
					<el-date-picker v-model="form2.KPdate" type="date" placeholder="可手动输入,如：20180101" :default-value="new Date()" value-format="timestamp" style="width: 300px;"></el-date-picker>
				</el-form-item>
				<el-form-item label="开票状态：" :label-width="formLabelWidth2">
					<el-radio v-model="form2.KPstate" label="1">已开票</el-radio>
					<el-radio v-model="form2.KPstate" label="2">未开票</el-radio>
				</el-form-item>
				<el-form-item label="发票编号：" :label-width="formLabelWidth2">
					<el-input placeholder="请填写修改内容" v-model="form2.KPnum" auto-complete="off" style="width: 300px;" :maxlength="8"></el-input>
				</el-form-item>
				<el-form-item label="收款日期1st：" :label-width="formLabelWidth2">
					<el-date-picker v-model="form2.SKdate" type="date" placeholder="可手动输入,如：20180101" value-format="timestamp" style="width: 300px;"></el-date-picker>
				</el-form-item>
				<el-form-item label="收款金额1st：" :label-width="formLabelWidth2">
					<el-input placeholder="请填写修改内容" v-model="form2.SKnum" auto-complete="off" style="width: 300px;"></el-input> 元
				</el-form-item>
				<el-form-item label="收款日期2nd：" :label-width="formLabelWidth2">
					<el-date-picker v-model="form2.SKdate2" type="date" placeholder="可手动输入,如：20180101" value-format="timestamp" style="width: 300px;"></el-date-picker>
				</el-form-item>
				<el-form-item label="收款金额2nd：" :label-width="formLabelWidth2">
					<el-input placeholder="请填写修改内容" v-model="form2.SKnum2" auto-complete="off" style="width: 300px;"></el-input> 元
				</el-form-item>
				<el-form-item label="收款日期3rd&after：" :label-width="formLabelWidth2">
					<el-date-picker v-model="form2.SKdate3" type="date" placeholder="可手动输入,如：20180101" value-format="timestamp" style="width: 300px;"></el-date-picker>
				</el-form-item>
				<el-form-item label="收款金额3rd&after：" :label-width="formLabelWidth2">
					<el-input placeholder="请填写修改内容" v-model="form2.SKnum3" auto-complete="off" style="width: 300px;"></el-input> 元
				</el-form-item>
				<el-form-item label="收款状态：" :label-width="formLabelWidth2">
					<el-radio v-model="form2.SKstate" label="1">押金</el-radio>
					<el-radio v-model="form2.SKstate" label="2">未收款</el-radio>
					<el-radio v-model="form2.SKstate" label="3">货款</el-radio>
				</el-form-item>
				<el-form-item label="押金转销售：" :label-width="formLabelWidth2">
					<el-radio v-model="form2.ischange" label="1">是</el-radio>
					<el-radio v-model="form2.ischange" label="0">否</el-radio>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" type="primary" @click="Sub2" :loading="Subloading2" style="padding: 10px 50px;">提 交</el-button>
			</div>
		</el-dialog>
		<el-dialog title="提示" :visible.sync="CWTSVisible" width="30%">
			<span>是否确认修改并提交？</span>
			<span slot="footer" class="dialog-footer">
				    <el-button @click="CWTSVisible = false">取 消</el-button>
				    <el-button type="primary" @click="Subdata2">确 定</el-button>
				</span>
		</el-dialog>

		<!--销售修改弹窗-->
		<el-dialog title="销售修改" :visible.sync="XSvisible" append-to-body center width="540px">
			<el-form :model="form3">
				<!--<el-form-item label="物流单号：" :label-width="formLabelWidth2">
					<el-input placeholder="请填写修改内容" v-model="form3.Wliunum" auto-complete="off" style="width: 300px;" :maxlength="12"></el-input>
				</el-form-item>-->
				<el-form-item label="合同编号：" :label-width="formLabelWidth2">
					<el-input placeholder="请填写修改内容" v-model="form3.HTnum" auto-complete="off" style="width: 300px;" :maxlength="30"></el-input>
				</el-form-item>
				<el-form-item label="合同金额：" :label-width="formLabelWidth2">
					<el-input placeholder="请填写修改内容" v-model="form3.HTmoney" auto-complete="off" style="width: 300px;"></el-input> 元
				</el-form-item>
				<el-form-item label="合同收款方式：" :label-width="formLabelWidth2">
					<el-input placeholder="请填写修改内容" v-model="form3.Colmethod" auto-complete="off" style="width: 300px;" :maxlength="30"></el-input>
				</el-form-item>
				<el-form-item label="合同收款日期" :label-width="formLabelWidth2">
					<el-date-picker v-model="form3.CoLdate" type="date" placeholder="可手动输入,如：20180101" value-format="timestamp" style="width: 300px;"></el-date-picker>
				</el-form-item>
				<el-form-item label="合同状态：" :label-width="formLabelWidth2">
					<el-radio v-model="form3.HTstate" label="1">已归档</el-radio>
					<el-radio v-model="form3.HTstate" label="2">未归档</el-radio>
				</el-form-item>
				<el-form-item label="产品所在地区：" :label-width="formLabelWidth2" prop="ssq">
					<el-cascader :options="Addoptions" v-model="form3.ssq" style="width: 300px;"></el-cascader>
				</el-form-item>
				<el-form-item label="详细地址：" :label-width="formLabelWidth2" prop="xxdz">
					<el-input v-model="form3.xxdz" placeholder="请填写详细地址" style="width: 300px;" :maxlength="50"></el-input>
				</el-form-item>
				<!--<el-form-item label="用户：" :label-width="formLabelWidth2">
					<el-input placeholder="请填写修改内容" v-model="form3.User" auto-complete="off" style="width: 300px;" :maxlength="30"></el-input>
				</el-form-item>
				<el-form-item label="用户联系方式：" :label-width="formLabelWidth2">
					<el-input placeholder="请填写修改内容" v-model="form3.UserPhone" auto-complete="off" style="width: 300px;" :maxlength="15"></el-input>
				</el-form-item>-->
				<el-form-item label="用户/设备负责人：" :label-width="formLabelWidth2">
					<el-input placeholder="请填写修改内容" v-model="form3.Principal" auto-complete="off" style="width: 300px;" :maxlength="30"></el-input>
				</el-form-item>
				<el-form-item label="联系方式：" :label-width="formLabelWidth2">
					<el-input placeholder="请填写修改内容" v-model="form3.PrincipalPhone" auto-complete="off" style="width: 300px;" :maxlength="15"></el-input>
				</el-form-item>
				<el-form-item label="客户特殊需求：" :label-width="formLabelWidth2">
					<el-input placeholder="请填写内容(最多250字)" type="textarea" autosize v-model="form3.SpecialNeeds" auto-complete="off" style="width: 300px;" :maxlength="250"></el-input>
				</el-form-item>
				<el-form-item label="产品类别：" :label-width="formLabelWidth2">
					<el-select v-model="form3.type" placeholder="请选择" style="width: 300px;">
    					<el-option v-for="item in typeFilt" :key="item.val" :label="item.label" :value="item.val"></el-option>
				  	</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" type="primary" @click="Sub3" :loading="Subloading3" style="padding: 10px 50px;">提 交</el-button>
			</div>
		</el-dialog>
		<el-dialog title="提示" :visible.sync="XSTSVisible" width="30%">
			<span>是否确认修改并提交</span>
			<span slot="footer" class="dialog-footer">
				    <el-button @click="XSTSVisible = false">取 消</el-button>
				    <el-button type="primary" @click="Subdata3">确 定</el-button>
				</span>
		</el-dialog>

		<!--产品修改页面-->
		<el-dialog title="产品修改" :visible.sync="CPvisible" width="1000px" append-to-body center>
			<el-form :model="form4">
				<el-form-item label="问题记录：" :label-width="formLabelWidth">
					<el-tag :key="tag" v-for="tag in form4.dynamicTags" closable :disable-transitions="false" @close="handleClose(tag)">{{tag}}</el-tag>
					<el-input class="input-new-tag" v-if="inputVisible" v-model="inputValue" ref="saveTagInput" size="small" @keyup.enter.native="handleInputConfirm" @blur="handleInputConfirm"></el-input>
					<el-button v-else class="button-new-tag" size="small" @click="showInput">+ 新问题</el-button>
				</el-form-item>
				<el-form-item label="备注：" :label-width="formLabelWidth">
					<el-input placeholder="请填写修改内容" v-model="form4.Remark" auto-complete="off" :maxlength="250"></el-input>
				</el-form-item>
				<el-form-item label="销售日期" :label-width="formLabelWidth">
					<el-date-picker value-format="timestamp" size="small" v-model="form4.sales_date" type="date" placeholder="可手动输入,如：20180101"></el-date-picker>
    			</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" type="primary" @click="Sub4" :loading="Subloading4" style="padding: 10px 50px;">提 交</el-button>
			</div>
		</el-dialog>
		<el-dialog title="提示" :visible.sync="CPTSVisible" width="30%">
			<span>是否确认修改并提交</span>
			<span slot="footer" class="dialog-footer">
				    <el-button @click="CPTSVisible = false">取 消</el-button>
				    <el-button type="primary" @click="Subdata4">确 定</el-button>
				</span>
		</el-dialog>
		
		<el-dialog title="提示" :visible.sync="leaderVisible" width="30%">
			<p style="font-size: 20px;">请选择需要修改的信息类别：</p>
			<el-radio-group v-model="leaderChiose">
    			<el-radio :label="1">生产信息</el-radio>
    			<el-radio :label="2">财务信息</el-radio>
    			<el-radio :label="3">销售信息</el-radio>
    			<el-radio :label="4">产品信息</el-radio>
  			</el-radio-group>
			<span slot="footer" class="dialog-footer">
				<el-button @click="leaderVisible = false">取 消</el-button>
				<el-button type="primary" @click="leaderOpen">确 定</el-button>
			</span>
		</el-dialog>
		

	</div>
</template>

<script>
	import { CountryThree } from '../common/js/countrythree'
	import { GetAfterInfo, GetDealerlist, GetDeliverlist } from '../api/api';
	import moment from 'moment'
	import FileSaver from 'file-saver'
    import XLSX from 'xlsx'

	//权限分为生产、销售、财务、产品
	export default {
		data() {
			return {
				checkList:[],
				loading: false,
				Limits: "",
				Dealerlist:[],
				getFilt:1,
//				DealerFilt:[],
//				DealerFilt2:[],
				formLabelWidth: '120px',
				formLabelWidth2: '150px',
				token: "",
				List: [],
				maxHeight: 950,
				Pagesize: 20,
				Curpage: 1,
				total: 20,
				leaderChiose:"",
				leaderVisible:false,
				listloading: false,
				inputwhat: "",
				SCvisible: false,
				SCTSVisible: false,
				CWvisible: false,
				CWTSVisible: false,
				XSvisible: false,
				XSTSVisible: false,
				CPvisible: false,
				CPTSVisible: false,
				Subloading1: false,
				Subloading2: false,
				Subloading3: false,
				Subloading4: false,
				form1: {
					ChuanDaiN:"",
					ChuanDaiXL:"",
					ChuanDaiM:"",
					ChuanDaiS:"",
					BanBen: "",
				},
				SCForm: {},
				form2: {
					KPdate: new Date(),
					KPstate: '',
					KPnum: '',
					SKdate: new Date(),
					SKstate: '',
					SKnum: '',
					SKdate2: new Date(),
					SKnum2: '',
					SKdate3: new Date(),
					SKnum3: '',
					ischange:''
				},
				CWForm: {},
				form3: {
					HTmoney: "",
					HTnum: "",
					HTstate: "",
					ssq: [],
					xxdz: "",
//					User: "",
//					UserPhone: "",
					Principal: "",
					PrincipalPhone: "",
					type:"",
//					Wliunum:"",
					Colmethod:"",
					SpecialNeeds:"",
					CoLdate:new Date()
				},
				XSForm: {},
				form4: {
					Question: "",
					dynamicTags:['问题一', '问题二', '问题三'],
					Remark: "",
					sales_date:''
				},
				CPForm: {},
				Addoptions: [],
				limA: false,
				limB: false,
				limC: false,
				limD: false,
				Rowline:{},
				id:"",
				typeFilt:[
					{
						label:'终端客户（个人）',
						val:1
					},{
						label:'终端客户（单位）',
						val:5
					},{
						label:'经销商客户（购销）',
						val:2
					},{
						label:'经销商客户（押金）',
						val:6
					},{
						label:'公司内部（市场）',
						val:3
					},{
						label:'公司内部（研发）',
						val:7
					},{
						label:'其他',
						val:4
					},
				],
//				dynamicTags: ,
        		inputVisible: false,
        		inputValue: '',
        		Choice:[
					{name:"DID",val:1,oten:"did"},
					{name:"发货单号",val:2,oten:"deliveryOrder.type_code"},
					{name:"发票编号",val:3,oten:"invoice.invoice_serial_number"},
					{name:"物流单号",val:4,oten:""},
					{name:"合同编号",val:5,oten:"contract.contract_serial_number"},
					{name:"用户/设备负责人",val:6,oten:"purchaserInfo.manager"},
					{name:"联系方式",val:7,oten:"purchaserInfo.manager_phone"}
				],
        		selectWhat:"",
        		inputWhat:"",
        		Tags:[],
        		selectKind:[],
        		selectColor:[],
        		selectJxs:[],
        		DIDinput:"",
        		selectTime:[],
        		qualt:{},
        		cw:false,
        		xs:false,
        		sc:false,
        		cp:false
			}
		},
		methods: {
			showChange(){
				var that = this
				console.log(that.checkList)
				if(that.checkList.includes('a')){that.cw = true}else{that.cw = false}
				if(that.checkList.includes('b')){that.xs = true}else{that.xs = false}
				if(that.checkList.includes('c')){that.sc = true}else{that.sc = false}
				if(that.checkList.includes('d')){that.cp = true}else{that.cp = false}
				console.log(that.cw,that.xs,that.sc,that.cp)
			},
			changeJxs(){
			},
			TagsHandleClose(tag){
				this.Tags.splice(this.Tags.indexOf(tag), 1);
			},
			addCondition(){
				var that = this
				var showText = ""
				var showTitle = ""
				if(that.selectWhat && that.inputWhat){
					for(var i in that.Choice){
						if(that.selectWhat == that.Choice[i].val){
							showTitle = that.Choice[i].name
						}
					}
					
					for(var i=0;i<that.Tags.length;i++){
						if(that.Tags[i].indexOf(showTitle) != -1){
							that.Tags.splice(i,1)
						}
					}
					showText = showTitle + ':' + that.inputWhat
					that.Tags.push(showText)
					that.selectWhat = ""
					that.inputWhat = ""
				}
			},
			DownExcel(){
				var that = this
				that.$prompt('请输入需要导出文件后的命名','提示',{
					confirmButtonText: '确定并导出',
          			cancelButtonText: '取消操作',
				}).then(({value}) => {
					that.exportExcelNew('#dataTable',value)
				})
			},
			exportExcelNew(id,title){
				var fix = document.querySelector('.el-table__fixed');
				  var wb;
				  if (fix) {
				    wb = XLSX.utils.table_to_book(document.querySelector(id).removeChild(fix));
				    document.querySelector(id).appendChild(fix);
				  } else {
				    wb = XLSX.utils.table_to_book(document.querySelector(id));
				  }
				  /* get binary string as output */
				  var wbout = XLSX.write(wb, {
				    bookType: 'xlsx',
				    bookSST: true,
				    type: 'array'
				  });
				  try {
				    FileSaver.saveAs(
				      new Blob([wbout], {
				        type: 'application/octet-stream'
				      }),
				      title + '.xlsx'
				    );
				  } catch (e) {
				    if (typeof console !== 'undefined') console.log(e, wbout);
				  }
				  return wbout;
			},
			refresh(){
				var that = this
				that.DIDinput = ""
				that.selectJxs = []
				that.selectTime = []
				that.Getlist()
			},
			search(){
				var that = this
				if(that.DIDinput || that.selectJxs.length > 0 || that.selectTime.length > 0){
					that.findList()
				}
			},
			findList(){
				var that = this
				if(that.DIDinput || that.selectJxs.length > 0 || that.selectTime.length > 0){
					that.listloading = true
					var inq = {}
					if(that.DIDinput){inq.did = {'like':that.DIDinput}}
					if(that.selectJxs.length > 0){inq.dealer_id = {'in':that.selectJxs}}
					if(that.selectTime.length > 0){inq['deliveryOrder.delivery_date'] = {">":that.selectTime[0]/1000,"<":that.selectTime[1]/1000}}
					var qualt = {
						'page':that.Curpage,
						'per-page':that.Pagesize,
						'sort':'-delivery_order.delivery_date'
					}
					if(JSON.stringify(inq) != '{}'){
						qualt.q = inq
						that.axios.post('/v2/device-info/search?token=' + that.token,qualt).then(res => {
						var getData = res.data.items
						console.log("res", res)
						for(var i=0;i<getData.length;i++){
							if(getData[i].purchaserInfo.province == getData[i].purchaserInfo.city){
								getData[i].add = getData[i].purchaserInfo.city + ',' + getData[i].purchaserInfo.district + ',' + getData[i].purchaserInfo.address
							}else{
								getData[i].add = getData[i].purchaserInfo.province + ',' + getData[i].purchaserInfo.city + ',' + getData[i].purchaserInfo.district + ',' + getData[i].purchaserInfo.address
							}
							if(getData[i].add == ',,,' || getData[i].add == ',,'){
								getData[i].add = "无"
							}
							getData[i].sequenceNumber = i + 1
						}
						
							that.List = getData
							that.Pagesize = res.data.meta.perPage
							that.total = res.data.meta.totalCount
							that.listloading = false
//							console.log("this.List", this.List)
						}).catch(err => {
							this.$message.error(err.response.data.message)
							this.List = []
						})
					}
				}else{
					that.Getlist()
				}
				
			},
			IDMACsearch(){
				
			},
			Filterfind(){
				
			},
			leaderOpen(){
				var row = this.Rowline
				var that = this
				that.leaderVisible = false
				if(that.leaderChiose == '1'){
					that.SCvisible = true
					that.form1.BanBen = row.version_number
					that.form1.ChuanDaiN = row.deliveryOrder.wearable_device & 255
					that.form1.ChuanDaiXL = (row.deliveryOrder.wearable_device >> 24) & 255
					that.form1.ChuanDaiM = (row.deliveryOrder.wearable_device >> 16) & 255
					that.form1.ChuanDaiS = (row.deliveryOrder.wearable_device >> 8) & 255
					
					that.form1.ChuanDai = row.deliveryOrder.wearable_device
				}else if(that.leaderChiose == '2'){
					that.CWvisible = true
					that.form2.KPdate = row.invoice.invoice_created_date*1000
					that.form2.KPstate = row.invoice.invoice_status + ''
					that.form2.KPnum = row.invoice.invoice_serial_number
					that.form2.SKdate = row.invoice.receipt_date*1000
					that.form2.SKnum = row.invoice.receipt_amount
					that.form2.SKdate2 = row.invoice.receipt_date_2nd*1000
					that.form2.SKnum2 = row.invoice.receipt_amount_2nd
					that.form2.SKdate3 = row.invoice.receipt_date_finally*1000
					that.form2.SKnum3 = row.invoice.receipt_amount_finally
					that.form2.ischange = row.invoice.is_deposit_to_sale +''
					that.form2.SKstate = row.invoice.receipt_status + ''
				}else if(that.leaderChiose == '3'){
					that.XSvisible = true
					that.form3.HTmoney = row.contract.contract_amount
					that.form3.HTnum = row.contract.contract_serial_number
					that.form3.HTstate = row.contract.contract_status + ""
					that.form3.ssq = [row.purchaserInfo.province,row.purchaserInfo.city,row.purchaserInfo.district]
					that.form3.xxdz = row.purchaserInfo.address
//					that.form3.User = row.purchaserInfo.customer
//					that.form3.UserPhone = row.purchaserInfo.customer_phone
					that.form3.Principal = row.purchaserInfo.manager
					that.form3.PrincipalPhone = row.purchaserInfo.manager_phone
					that.form3.type = row.deliveryOrder.type_code
//					that.form3.Wliunum = row.deliveryOrder.shipment_number
					that.form3.SpecialNeeds = row.purchaserInfo.customer_special_needs
					that.form3.Colmethod = row.contract.contract_payment_method
					that.form3.CoLdate = row.contract.contract_collection_date
				}else if(that.leaderChiose == '4'){
					that.CPvisible = true
					that.form4.dynamicTags = row.afterSaleOrder.problemCodes
					that.form4.Remark = row.afterSaleOrder.remark
					that.form4.sales_date = row.afterSaleOrder.sales_date*1000
				}
			},
			ChangeIt(row, event){
				var that = this
				console.log(row)
				this.Rowline = row
				this.id = row.id
				if(that.limA && that.limB && that.limC && that.limD){
					that.leaderVisible = true
					that.leaderChiose = 0
				}
				else if(that.limA){
					that.SCvisible = true
					that.form1.BanBen = row.version_number
					that.form1.ChuanDaiN = row.deliveryOrder.wearable_device & 255
					that.form1.ChuanDaiXL = (row.deliveryOrder.wearable_device >> 24) & 255
					that.form1.ChuanDaiM = (row.deliveryOrder.wearable_device >> 16) & 255
					that.form1.ChuanDaiS = (row.deliveryOrder.wearable_device >> 8) & 255
				}else if(that.limB){
					that.CWvisible = true
					that.form2.KPdate = row.invoice.invoice_created_date*1000
					that.form2.KPstate = row.invoice.invoice_status + ''
					that.form2.KPnum = row.invoice.invoice_serial_number
					that.form2.SKdate = row.invoice.receipt_date*1000
					that.form2.SKnum = row.invoice.receipt_amount
					that.form2.SKdate2 = row.invoice.receipt_date_2nd*1000
					that.form2.SKnum2 = row.invoice.receipt_amount_2nd
					that.form2.SKdate3 = row.invoice.receipt_date_finally*1000
					that.form2.SKnum3 = row.invoice.receipt_amount_finally
					that.form2.ischange = row.invoice.is_deposit_to_sale + ''
					that.form2.SKstate = row.invoice.receipt_status + ''
				}else if(that.limC){
					that.XSvisible = true
					that.form3.HTmoney = row.contract.contract_amount
					that.form3.HTnum = row.contract.contract_serial_number
					that.form3.HTstate = row.contract.contract_status + ""
					that.form3.ssq = [row.purchaserInfo.province,row.purchaserInfo.city,row.purchaserInfo.district]
					that.form3.xxdz = row.purchaserInfo.address
//					that.form3.User = row.purchaserInfo.customer
//					that.form3.UserPhone = row.purchaserInfo.customer_phone
					that.form3.Principal = row.purchaserInfo.manager
					that.form3.PrincipalPhone = row.purchaserInfo.manager_phone
					that.form3.type = row.deliveryOrder.type_code
//					that.form3.Wliunum = row.deliveryOrder.shipment_number
					that.form3.SpecialNeeds = row.purchaserInfo.customer_special_needs
					that.form3.Colmethod = row.contract.contract_payment_method
					that.form3.CoLdate = row.contract.contract_collection_date
				}else if(that.limD){
					that.CPvisible = true
					that.form4.dynamicTags = row.afterSaleOrder.problemCodes
					that.form4.Remark = row.afterSaleOrder.remark
					that.form4.sales_date = row.afterSaleOrder.sales_date*1000
				}
			},
//			分页跳转
			handleCurrentChange(val) {
				this.Curpage = val
				this.findList()
			},
			handleSizeChange(val){
				this.Pagesize = val
				this.findList()
			},
			EditionCode(para){
				if(para == '1'){return "标准"}
				else if(para == '2'){return "运动"}
				else {return "未知"}
			},
//			合同收款方式
//			paymentterm(){
//				if(para == '1'){return "是"}
//				else if(para == '0'){return "否"}
//				else {return "未知"}
//			},
//			是否现金转销售
			cashtosell(para){
				if(para == '1'){return "是"}
				else if(para == '0'){return "否"}
				else {return ""}
			},
//			经销商格式化
			jxs(para){
				var that = this
				for(var i =0;i<that.Dealerlist.length;i++){
					if(para == that.Dealerlist[i].id){
						return that.Dealerlist[i].name
					}
				}
			},
//			设备类别
			typeCodeForm(para) {
				if(para == '1') {
					return '终端客户（个人）'
				} else if(para == '2') {
					return '经销商客户（购销）'
				} else if(para == '3') {
					return '公司内部（市场）'
				}else if(para == '4') {
					return '其他'
				}else if(para == '5') {
					return '终端客户（单位）'
				}else if(para == '6') {
					return '经销商客户（押金）'
				}
				else if(para == '7') {
					return '公司内部（研发）'
				}
			},
//			颜色类型
			colorCode(para){
				if(para == '1'){return '黑金'}
				else if(para == '2'){return '白红'}
				else if(para == '3'){return '白灰'}
				else if(para == '5'){return '样机'}
				else if(para == '6'){return '钢铁侠'}
				else if(para == '7'){return '酒红'}
				else if(para == '8'){return '纯黑'}
				else if(para == '9'){return '鸟蓝'}
				else if(para == '10'){return '粉白'}
				else if(para == '256'){return '白色'}
				else if(para == '257'){return '红色'}
				else {return '未知'}
			},
//			气弹簧
			springCode(para){
				if(para == '1'){return '600N'}
				else if(para == '2'){return '800N'}
				else if(para == '3'){return '电动摆臂'}
				else {return '未知'}
			},
//			开票状态
			invoiceState(para){
				if(para == '1'){return '已开票'}
				else if(para == '2'){return '未开票'}
				else {return ''}
				
			},
//			收款状态
			paymentState(para){
				if(para == '1'){return '押金'}
				else if(para == '2'){return '未收款'}
				else if(para == '3'){return '货款'}
				else {return ''}
			},
//			合同状态
			contractState(para){
				if(para == '1'){return '已归档'}
				else if(para == '2'){return '未归档'}
				else {return ''}
			},
//			穿戴解码
			wareCode(para){
				var n = para & 255
				var s = (para >> 8)&255
				var m = (para >> 16)&255
				var xl = (para >> 24)&255
				
			},
//			问题记录
			problemRecord(para){
				if(para.length > 0){
					var str = ''
					for(var i=0;i<para.length;i++){
//						arr.push(para[i].problem_code) 
						str += para[i] + ','
					}
					str = str.substring(0,str.length-1)
					return str
				}else{
					return "无"
				}
				
			},
			timeFormate(para) {
				if(para == "") {
					return ""
				} else {
					var date = para * 1000
					if(date == undefined) {
						return 'undefined'
					} else if(date == 0) {
						return "0"
					}
					return moment(date).format("YYYY-MM-DD")
				}
			},
//			生产修改
			Sub1() {
				this.SCTSVisible = true
			},
			Subdata1() {
				var that = this
				that.SCTSVisible = false
				that.Subloading1 = true
				var chuandai = that.form1.ChuanDaiN*Math.pow(16,0) + that.form1.ChuanDaiS*Math.pow(16,2) + that.form1.ChuanDaiM*Math.pow(16,4) + that.form1.ChuanDaiXL*Math.pow(16,6)
				console.log("chuandai",chuandai)
				var param = {
					"version_number": that.form1.BanBen,
					"wearable_device": chuandai
				}
				var url = '/v2/device-info/' + this.id + '/base?token=' + this.token
				this.axios.put(url,param).then(res => {
					if(res.status == 200){
						this.$message({
				            type: 'success',
				            message: '恭喜你，操作成功!'
				        });
				        that.Subloading1 = false
				        that.SCvisible = false
				        this.Getlist()
					}else{
						that.Subloading1 = false
						that.$message.error('对不起，请求失败。')
					}
					console.log(res)
				}).catch(err => {
					console.log(err.message)
					that.Subloading1 = false
					that.$message.error(err.response.data.message)
				})
			},
			//			财务修改
			Sub2() {
				this.CWTSVisible = true
			},
			Subdata2() {
				var that = this
				that.CWTSVisible = false
				that.Subloading2 = true
				var param = {
					"invoice_serial_number": that.form2.KPnum,
					"invoice_created_date": that.form2.KPdate/1000,
				    "invoice_status": that.form2.KPstate,
				    "receipt_date": that.form2.SKdate/1000,
				    "receipt_amount": that.form2.SKnum,
				    "receipt_date_2nd":that.form2.SKdate2/1000,
				    "receipt_amount_2nd":that.form2.SKnum2,
				    "receipt_date_finally":that.form2.SKdate3/1000,
				    "receipt_amount_finally":that.form2.SKnum3,
				    "is_deposit_to_sale":that.form2.ischange,
				    "receipt_status": that.form2.SKstate
				}
				console.log("param",param)
				var url = '/v2/device-info/' + this.id + '/invoice?token=' + this.token
				this.axios.put(url,param).then(res => {
					if(res.status == 200){
						this.$message({
				            type: 'success',
				            message: '恭喜你，操作成功!'
				        });
				        that.Subloading2 = false
				        that.CWvisible = false
				        this.Getlist()
					}else{
						that.Subloading2 = false
						that.$message.error('对不起，请求失败。')
					}
					console.log(res)
				}).catch(err => {
					console.log(err)
					that.Subloading2 = false
					that.$message.error(err.response.data.message)
				})
//				
//				
//				this.CWvisible = false
			},
			//			销售修改
			Sub3() {
				this.XSTSVisible = true
			},
			Subdata3() {
				var that = this
				that.XSTSVisible = false
				that.Subloading3 = true
				var param = {
					"contract_serial_number":that.form3.HTnum,
					"contract_amount": that.form3.HTmoney,
					"contract_status": that.form3.HTstate,
					"province": that.form3.ssq[0],
					"city": that.form3.ssq[1],
					"district": that.form3.ssq[2],
					"address": that.form3.xxdz,
//					"customer": that.form3.User, 
//					"customer_phone": that.form3.UserPhone,
					"manager": that.form3.Principal,
					"manager_phone": that.form3.PrincipalPhone,
					"type_code":that.form3.type,
//					"shipment_number":that.form3.Wliunum,
					"customer_special_needs":that.form3.SpecialNeeds,
					"contract_payment_method":that.form3.Colmethod,
					"contract_collection_date":that.form3.CoLdate/1000
				}
				console.log(param)
				var url = '/v2/device-info/' + this.id + '/sale?token=' + this.token
				this.axios.put(url,param).then(res => {
					if(res.status == 200){
						this.$message({
				            type: 'success',
				            message: '恭喜你，操作成功!'
				        });
				        that.Subloading3 = false
				        that.XSvisible = false
				        this.Getlist()
					}else{
						that.Subloading3 = false
						that.$message.error('对不起，请求失败。')
					}
					console.log(res)
				}).catch(err => {
					console.log(err)
					that.Subloading3 = false
					that.$message.error(err.response.data.message)					
				})
			},
			//			产品修改
			Sub4() {
				this.CPTSVisible = true
			},
			Subdata4() {
				var that = this
				that.CPTSVisible = false
				that.Subloading4 = true
				var param = {
					"remark": that.form4.Remark,
					"problemCodes": that.form4.dynamicTags,
					"sales_date":that.form4.sales_date/1000
				}
				console.log(param)
				var url = '/v2/device-info/' + this.id + '/after-sale?token=' + this.token
				this.axios.put(url,param).then(res => {
					if(res.status == 200){
						this.$message({
				            type: 'success',
				            message: '恭喜你，操作成功!'
				        });
				        that.Subloading4 = false
				        that.CPvisible = false
				        this.Getlist()
					}else{
						that.Subloading4 = false
						that.$message.error('对不起，请求失败。')
					}
					console.log(res)
				}).catch(err => {
					console.log(err)
					that.Subloading4 = false
					that.$message.error(err.response.data.message)
				})
			},
			handleClose(tag) {
        		this.form4.dynamicTags.splice(this.form4.dynamicTags.indexOf(tag), 1);
      		},
	      	showInput() {
	        	this.inputVisible = true;
	        	this.$nextTick(_ => {
	          		this.$refs.saveTagInput.$refs.input.focus();
	        	});
	      	},
	      	handleInputConfirm() {
        		let inputValue = this.inputValue;
        		if (inputValue) {
          			this.form4.dynamicTags.push(inputValue);
        		}
		        this.inputVisible = false;
		        this.inputValue = '';
      		},
			Getlist() {
				this.listloading = true
				var param = {
					'token': this.token,
					'page': this.Curpage,
					'per-page':this.Pagesize,
					'sort':'-delivery_order.delivery_date'
				}
				GetAfterInfo(param).then(res => {
					var getData = res.data.items
					console.log("res", res)
					for(var i=0;i<getData.length;i++){
						if(getData[i].purchaserInfo.province == getData[i].purchaserInfo.city){
							getData[i].add = getData[i].purchaserInfo.city + ',' + getData[i].purchaserInfo.district + ',' + getData[i].purchaserInfo.address
						}else{
							getData[i].add = getData[i].purchaserInfo.province + ',' + getData[i].purchaserInfo.city + ',' + getData[i].purchaserInfo.district + ',' + getData[i].purchaserInfo.address
						}
						if(getData[i].add == ',,,' || getData[i].add == ',,'){
							getData[i].add = "无"
						}
						getData[i].sequenceNumber = i + 1
					}
					
					this.List = getData
					this.Pagesize = res.data.meta.perPage
					this.total = res.data.meta.totalCount
					this.listloading = false
//					console.log("this.List", this.List)
				}).catch(err => {
					this.$message.error(err.response.data.message)
					this.List = []
					//					this.listloading = false
				})
			}
		},
		created() {
			this.token = sessionStorage.getItem("BBRtoken");
			this.GetDealerList(GetDealerlist)
//			this.DealerFilt = JSON.parse(sessionStorage.getItem("Dealerlist"));
//			if(this.DealerFilt){
//				this.GetDealerFilt(this.DealerFilt)
//			}
			this.Limits = JSON.parse(sessionStorage.getItem("limits"))
			if(this.Limits.device_info_updateBase){this.limA = true}
			if(this.Limits.device_info_updateInvoice){this.limB = true}
			if(this.Limits.device_info_updateSale){this.limC = true}
			if(this.Limits.device_info_updateAfterSale){this.limD = true}
//			console.log(this.Dealerlist)
			this.Addoptions = CountryThree
			var par = {'id':{'like':'1'}}
			this.Getlist()
		},
		mounted() {
			this.$nextTick(function() {
				
				var container = document.getElementsByClassName('content-container')
				var Cheight = container[0].clientHeight
				//				console.log("container[0].clientHeight",container[0].clientHeight)
				var breadcrumb = document.getElementsByClassName('breadcrumb-container')
				var Bheight = breadcrumb[0].offsetHeight
				//				console.log("breadcrumb[0].offsetHeight",breadcrumb[0].offsetHeight)
				this.maxHeight = Cheight - Bheight - 50 - 41 - 40 - 20 - 50
			})
		}
	}
</script>

<style>
	.el-table--border th, .el-table__fixed-right-patch {
		border: 1px solid #e5e5e5;
	}
	.el-table--border td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
		border: 1px solid #e5e5e5;
	}
	.el-table thead.is-group th {
		background: white;
	}
	.changeColor {
		color: dodgerblue;
	}
	.el-tag + .el-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }
  .wareUl {
  	list-style: none;
  	margin: 0;
  	padding: 0;
  }
  #onlineSelect .el-select{
  	width: 170px;
  }
</style>


// WEBPACK FOOTER //
// AfterSalesTrackingStand.vue?9e44d116